import { render, staticRenderFns } from "./salesSettleOrderbyAccount.vue?vue&type=template&id=af22e280&scoped=true"
import script from "./salesSettleOrderbyAccount.vue?vue&type=script&lang=js"
export * from "./salesSettleOrderbyAccount.vue?vue&type=script&lang=js"
import style0 from "./salesSettleOrderbyAccount.vue?vue&type=style&index=0&id=af22e280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af22e280",
  null
  
)

export default component.exports